import { useLocation } from "react-router-dom";
import { useAuth } from "../../common/hooks/useAuth";
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function ProtectedRoute({ children }) {
  const auth = useAuth();
  const location = useLocation();

  const [passwordExpired, setPasswordExpired] = useState();
  useEffect(() => {
    async function setPasswordExpiredAsync() {
      const result = await auth.isPasswordExpired();
      setPasswordExpired(result);
    }
    setPasswordExpiredAsync();
  }, [auth]);

  console.debug(location);

  if (auth.isRefreshTokenExpired()) {
    // A re-login after session timeout will always redirect to home
    return (
      <Navigate to="/login" replace />
    );

  } else if (auth.existsAccessToken()) {
    if (passwordExpired === undefined) {
      // Promise has not completed yet.
      // Note: React does not wait before rendering
      return null;

    } else if (passwordExpired === "J") {
      // Lisa web password expires.
      // May also happen, if user must change has password,
      // but manually navigates to protected route. Access token
      // is then already created, because change password dialog needs
      // texts which are configured in lisa.lims.
      return (
        <Navigate to="/login" replace />
      );

    } else {
      // Common flow for existing user
      // Attention: See axios interceptor for refresh token / rolling access token
      return children;
    }
  } else {
    // Direct navigation to protected route after re-login
    return (
      <Navigate
        to="/login"
        replace
        state={{
          path: location.pathname,
          search: location.search,
        }}
      />
    );
  }
}
